(function () {
  'use strict';

  if (window.__glazeGiftSimpleLoaded) return;
  window.__glazeGiftSimpleLoaded = true;

  var GIFT_VARIANT_ID = 49670323896632;
  var AUTO_GIFT_VALUE = 'glaze-ph-lip-treatment';
  var AUTO_GIFT_SYNC_VALUE = 'true';

  var ELIGIBLE_HANDLES = [
    'boss-babe-lipstick-copy',
    'brown-anatomy-dusk-till-dawn-liquid-lipstick-copy',
    'lost-love-lipstick-copy',
    'brown-anatomy-midnight-crush-liquid-lipstick-copy',
    'brown-anatomy-divine-feminine-liquid-lipstick-copy',
    'be-my-juliet-lipstick-copy',
    'be-my-juliet-buy-2-get-1-copy',
    'cleopatra-1-copy',
    'lady-diana-copy',
    'be-my-juliet-b1g1-copy'
  ];

  var eligibleHandleSet = new Set(ELIGIBLE_HANDLES);
  var timer = null;
  var isChecking = false;
  var isAddingGift = false;
  var checkoutLocked = false;
  var lastRunAt = 0;
  var lastGiftSignature = '';

  function rootUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (window.routes && window.routes.root) ||
      '/';

    return String(root || '/').replace(/\/?$/, '/');
  }

  function cartUrl(path) {
    return rootUrl() + String(path || '').replace(/^\//, '');
  }

  function isBreezeOnlyCheckout() {
    return window.BREEZE_ONLY !== false;
  }

  function goToShopifyCheckout() {
    window.location.href = cartUrl('/checkout');
  }
  function pathFromUrl(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (error) {
      return String(url || '');
    }
  }

  function isCartAddUrl(url) {
    return /\/cart\/add(\.js)?$/.test(pathFromUrl(url));
  }

  function itemHandle(item) {
    if (!item) return '';
    if (item.handle) return item.handle;
    if (item.product_handle) return item.product_handle;

    if (item.url) {
      var match = item.url.match(/\/products\/([^/?#]+)/);
      if (match) return match[1];
    }

    return '';
  }

  function itemVariantId(item) {
    return Number(item && (item.variant_id || item.id));
  }

  function itemProperty(item, name) {
    var properties = item && item.properties ? item.properties : {};

    if (Array.isArray(properties)) {
      var property = properties.find(function (entry) {
        return entry && (entry.name === name || entry[0] === name);
      });

      return property ? (property.value || property[1]) : undefined;
    }

    return properties[name];
  }

  function isAutoGiftItem(item) {
    return itemVariantId(item) === GIFT_VARIANT_ID &&
      itemProperty(item, '_auto_free_gift') === AUTO_GIFT_VALUE &&
      itemProperty(item, '_auto_free_gift_sync') === AUTO_GIFT_SYNC_VALUE;
  }

  function isManualGiftItem(item) {
    return !isAutoGiftItem(item) &&
      (itemVariantId(item) === GIFT_VARIANT_ID || itemHandle(item) === 'lip-treatment-copy');
  }

  function isEligibleItem(item) {
    if (isAutoGiftItem(item) || isManualGiftItem(item)) return false;

    return eligibleHandleSet.has(itemHandle(item));
  }

  function getCart() {
    return fetch(cartUrl('/cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart check failed');
      return response.json();
    });
  }

  function giftItem(cart) {
    return (cart.items || []).find(isAutoGiftItem);
  }

  function desiredGiftQuantity(cart) {
    return (cart.items || []).reduce(function (total, item) {
      return isEligibleItem(item) ? total + Number(item.quantity || 0) : total;
    }, 0);
  }

  function addGlazeGift(quantity) {
    isAddingGift = true;

    return fetch(cartUrl('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: GIFT_VARIANT_ID,
        quantity: quantity || 1,
        properties: {
          _auto_free_gift: AUTO_GIFT_VALUE,
          _auto_free_gift_sync: AUTO_GIFT_SYNC_VALUE
        }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Gift add failed');
      return response.json();
    }).finally(function () {
      isAddingGift = false;
    });
  }

  function updateGiftQuantity(item, quantity) {
    if (!isAutoGiftItem(item)) return Promise.resolve();

    var updates = {};
    updates[item && item.key ? item.key : GIFT_VARIANT_ID] = quantity;
    isAddingGift = true;

    return fetch(cartUrl('/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error('Gift quantity update failed');
      return response.json();
    }).finally(function () {
      isAddingGift = false;
    });
  }

  function syncGlazeGift(cart) {
    var desiredQuantity = desiredGiftQuantity(cart);
    var gift = giftItem(cart);

    if (desiredQuantity <= 0) {
      return Promise.resolve(cart);
    }

    if (!gift) {
      return addGlazeGift(desiredQuantity).then(getCart).then(markGiftChanged);
    }

    if (Number(gift.quantity) < desiredQuantity) {
      return updateGiftQuantity(gift, desiredQuantity).then(getCart).then(markGiftChanged);
    }

    return Promise.resolve(cart);
  }

  function cartGiftSignature(cart) {
    var gift = giftItem(cart);
    return desiredGiftQuantity(cart) + ':' + (gift ? gift.quantity : 0);
  }

  function markGiftChanged(cart) {
    cart.__glazeGiftChanged = true;
    lastGiftSignature = cartGiftSignature(cart);
    return cart;
  }

  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = cart.item_count < 100 ? cart.item_count : '99+';
    });

    document.querySelectorAll('[data-cart-text]').forEach(function (node) {
      node.textContent = cart.item_count === 1 ? 'item' : 'items';
    });
  }

  function refreshVisibleCartOnce(cart) {
    updateCartCount(cart);

    if (
      document.body.classList.contains('cart-sidebar-show') &&
      window.sharedFunctions &&
      typeof window.sharedFunctions.updateSidebarCart === 'function'
    ) {
      window.sharedFunctions.updateSidebarCart(cart);
      return;
    }

    if (document.body.classList.contains('template-cart')) {
      refreshMainCartOnce();
    }
  }

  function ensureGiftBeforeCheckout() {
    return getCart()
      .then(syncGlazeGift)
      .then(function (cart) {
        updateCartCount(cart);
        return cart;
      });
  }

  function getBreezeCheckout() {
    return window.breeze && typeof window.breeze.startCheckout === 'function'
      ? window.breeze.startCheckout.bind(window.breeze)
      : null;
  }

  function openBreezeCheckout() {
    var startCheckout = getBreezeCheckout();

    if (!startCheckout) return false;

    startCheckout();
    return true;
  }

  function waitForBreezeCheckout(timeout) {
    return new Promise(function (resolve) {
      var startedAt = Date.now();

      if (openBreezeCheckout()) {
        resolve(true);
        return;
      }

      var interval = window.setInterval(function () {
        if (openBreezeCheckout()) {
          window.clearInterval(interval);
          resolve(true);
          return;
        }

        if (Date.now() - startedAt >= timeout) {
          window.clearInterval(interval);
          resolve(false);
        }
      }, 100);
    });
  }

  function releaseCheckoutLockSoon() {
    window.setTimeout(function () {
      checkoutLocked = false;
    }, 1500);
  }

  function handleBreezeCheckoutResult(opened) {
    if (!opened) {
      checkoutLocked = false;
      console.warn('[glaze-free-gift] Breeze checkout is not available yet.');
      return;
    }

    releaseCheckoutLockSoon();
  }

  function goToFreshCheckout() {
    if (checkoutLocked) return;

    checkoutLocked = true;

    ensureGiftBeforeCheckout()
      .then(function () {
        if (!isBreezeOnlyCheckout()) {
          goToShopifyCheckout();
          return;
        }

        return waitForBreezeCheckout(4000).then(handleBreezeCheckoutResult);
      })
      .catch(function (error) {
        console.warn('[glaze-free-gift checkout]', error);

        if (!isBreezeOnlyCheckout()) {
          goToShopifyCheckout();
          return;
        }

        waitForBreezeCheckout(4000).then(handleBreezeCheckoutResult);
      });
  }

  function isCheckoutElement(element) {
    if (!element || !element.closest) return false;

    if (isBreezeOnlyCheckout() && element.closest('.shiprocket-headless, .sr-headless-checkout, breeze-button')) {
      return false;
    }

    var checkoutTarget = element.closest(
      '[name="checkout"], #cart-checkout, #cart-sidebar-checkout, .button-checkout, a[href*="/checkout"], a[href*="/checkouts"], button[onclick*="/checkout"], button[onclick*="/checkouts"], [data-href*="/checkout"], [data-href*="/checkouts"]'
    );

    if (checkoutTarget) return true;

    var text = (element.textContent || '').trim().toLowerCase();
    return text === 'checkout' || text === 'proceed to checkout';
  }

  function refreshMainCartOnce() {
    var mainCart = document.querySelector('#main-cart-items');
    if (!mainCart) return;

    var sectionId = mainCart.getAttribute('data-id');
    if (!sectionId) return;

    fetch(cartUrl('/cart?section_id=' + encodeURIComponent(sectionId)), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Main cart refresh failed');
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newMainCart = doc.querySelector('#main-cart-items');
        var currentCart = document.querySelector('#main-cart-items');

        if (newMainCart && currentCart) {
          currentCart.innerHTML = newMainCart.innerHTML;
        }
      })
      .catch(function (error) {
        console.warn('[glaze-free-gift main-cart]', error);
      });
  }

  function checkAndAddGlazeGift(refreshVisibleCart) {
    var now = Date.now();

    if (isChecking || isAddingGift) return Promise.resolve();
    if (now - lastRunAt < 500) return Promise.resolve();

    isChecking = true;
    lastRunAt = now;

    return getCart()
      .then(function (cart) {
        updateCartCount(cart);

        var beforeSignature = cartGiftSignature(cart);

        if (beforeSignature === lastGiftSignature) {
          return cart;
        }

        return syncGlazeGift(cart)
          .then(function (updatedCart) {
            var changed = updatedCart.__glazeGiftChanged || beforeSignature !== cartGiftSignature(updatedCart);

            lastGiftSignature = cartGiftSignature(updatedCart);

            if (changed && refreshVisibleCart) {
              refreshVisibleCartOnce(updatedCart);
            } else {
              updateCartCount(updatedCart);
            }

            return updatedCart;
          });
      })
      .catch(function (error) {
        console.warn('[glaze-free-gift]', error);
      })
      .finally(function () {
        isChecking = false;
      });
  }

  function scheduleCheck(delay, refreshVisibleCart) {
    if (isChecking || isAddingGift) return;

    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      checkAndAddGlazeGift(refreshVisibleCart);
    }, typeof delay === 'number' ? delay : 800);
  }

  function hookFetchCartAdd() {
    if (!window.fetch || window.fetch.__glazeGiftSimpleFetchHooked) return;

    var originalFetch = window.fetch;

    window.fetch = function () {
      var requestUrl = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
      var shouldCheck = !isAddingGift && isCartAddUrl(requestUrl);

      return originalFetch.apply(this, arguments).then(function (response) {
        if (shouldCheck) scheduleCheck(900, true);
        return response;
      });
    };

    window.fetch.__glazeGiftSimpleFetchHooked = true;
  }

  function hookJqueryCartAdd() {
    if (!window.jQuery || !window.jQuery(document).ajaxComplete) return;

    window.jQuery(document).ajaxComplete(function (_event, _xhr, settings) {
      if (!isAddingGift && settings && isCartAddUrl(settings.url)) {
        scheduleCheck(900, true);
      }
    });
  }

  function bindFallbacks() {
    document.addEventListener('click', function (event) {
      var checkoutButton = event.target && isCheckoutElement(event.target);

      if (!checkoutButton) return;
      if (checkoutLocked) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      goToFreshCheckout();
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      var active = document.activeElement;
      var isCartCheckoutForm = form && form.matches && form.matches('form[action*="/cart"]') &&
        (
          form.querySelector('[name="checkout"]') ||
          form.querySelector('#cart-checkout') ||
          form.querySelector('.button-checkout') ||
          isCheckoutElement(active)
        );

      if (!isCartCheckoutForm) return;
      if (checkoutLocked) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      goToFreshCheckout();
    }, true);

    document.addEventListener('submit', function (event) {
      if (event.target && event.target.matches('form[action*="/cart/add"]')) {
        scheduleCheck(1000, true);
      }
    }, true);

    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest('[data-cart-remove]')) {
        scheduleCheck(1000, true);
      }
    }, true);

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('[data-cart-quantity]')) {
        scheduleCheck(1000, true);
      }
    }, true);

    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest('[data-cart-sidebar]')) {
        scheduleCheck(300, true);
      }
    }, true);
  }

  function runInitialCheck() {
    getCart().then(updateCartCount).catch(function () {});
  }

  hookFetchCartAdd();
  hookJqueryCartAdd();
  bindFallbacks();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInitialCheck);
  } else {
    runInitialCheck();
  }

  window.addEventListener('pageshow', function () {
    getCart().then(updateCartCount).catch(function () {});
  });

  window.GlazeFreeGift = {
    run: function () {
      return checkAndAddGlazeGift(true);
    }
  };
})();
